const TEXT = {
    REGISTER_CONTENT_TEXT_1:"注册",
    REGISTER_CONTENT_TEXT_2:"请输入手机号",
    REGISTER_CONTENT_TEXT_3:"请输入密码",
    REGISTER_CONTENT_TEXT_4:"请输入验证码",
    REGISTER_CONTENT_TEXT_5:"请输入昵称",
    REGISTER_CONTENT_TEXT_6:"我是女生",
    REGISTER_CONTENT_TEXT_7:"我是男生",
    REGISTER_CONTENT_TEXT_8:"立即注册",
    REGISTER_CONTENT_TEXT_9:"已有账号？去登录",
    REGISTER_CONTENT_TEXT_10:"发送验证码",
};
export {
	TEXT
}



// WEBPACK FOOTER //
// ./src/config/page/cn/register/index.js